import React, {Component} from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';
import swal from 'sweetalert';
import { Table} from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';


var Config = require('../../../config');


class DevolutionProducts extends Component{
	constructor(props){
		super(props);

		this.getLotes = this.getLotes.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onCancel = this.onCancel.bind(this);

		this.state = {
			table_reserve:[],
			solicited_products:[],

			no_file:"",
			patient:"",
			group_rh:"",
			center_sent:"",
		}

	}

	componentDidMount(){
		var id = this.props.match.params.id;

		


		fetch(Config.default.apiGateway.URL+'petitions/get_products/'+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined ){
				var products = [];
				response.map((res)=>{
					res.send_amount = 0;
					res.export_id = "";
					res.lote_selected = "";
					res.lotes = [];
					//res.amount_received = 0;
				})
				this.setState({solicited_products:response});

				setTimeout(()=>{
					//this.getLotes();
					this.getSavedProducts(id);
				}, 500);
				
			}
		});		
	}

	getLotes(){
		fetch(Config.default.apiGateway.URL+'plasmatic_product/stock/'+
			sessionStorage.getItem('health_facilities_id'), {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var lotes = [];
				response.map((res, i)=>{
					var index = this.state.solicited_products.findIndex(obj => 
						obj.name === res.product.name
					)
					if(index !== -1){
						res.stock.map((s)=>{
							this.state.solicited_products[index].id_product = res.product.id;
							this.state.solicited_products[index].lotes.push({
								lote:s.lot_number,
								total: s.total
							});
						})
					}
						
				})
				
				this.forceUpdate();

				setTimeout(()=>{
					this.getSavedProducts(this.props.match.params.id);
				}, 500)
				
			}
		});
	}

	getSavedProducts(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasmatic_product_export/grouped/petition_id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined && response !== null){
				var cantidad = 0, pendiente = 0;

				response.map((res)=>{

					var index = this.state.solicited_products.findIndex(obj => 
						obj.plasmatic_product_id === res.plasmatic_product_id
					)

					var cant_devolution = res.devolutions;
				
					if(index !== -1){
						var total = res.sended - cant_devolution;
						this.state.solicited_products[index].send_amount += total;

						if(total > 0){
							this.state.solicited_products[index].lotes.push({
								lote:res.lot_number,
								total: total
							});
						}
							
					}

				});

				this.forceUpdate();

			}
		});	
	}

	onSave(){
		var obj = [];
		var id = this.props.match.params.id;

		this.state.solicited_products.map((s)=>{
			if(s.amount_received !== "" && s.lote_selected !== ""){
				obj.push({
					product_id:s.plasmatic_product_id,
					lot_number:s.lote_selected,
					amount:s.amount_received,
				})
			}
				
		})
		
		if(obj.length > 0){
			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+'plasmatic_product_returns/'+
				sessionStorage.getItem('health_facilities_id')+'/'+id,{
				method: 'post',
				body: JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return 'ok';
				}
			}).then(response => {
				if(response !== undefined){
					swal('Proceso Terminado', 'La devolución se realizó correctamente', 'success');
					this.props.history.push('/petition_register');
				}
			})
		}else{
			swal('Error', 'Debe llenar los campos', 'error');
		}
			
	}

	onCancel(){
		this.props.history.push("/petition_register");
	}

  	handleChange(e){
  		var campo = e.target.id.split('_');
  		var id = parseInt(campo[1]);
  		var pos = campo[2];
  		var index = -1;
  		var valor = e.target.value;

  		index = this.state.solicited_products.findIndex(obj => 
			obj.plasmatic_product_id === id
		);
		if(campo[0] === 'prod'){
			this.state.solicited_products[index].amount_received = parseInt(valor);
			this.forceUpdate();
		}
  		
  		if(campo[0] === 'lot'){
  			var cantidad_disponible = parseInt(e.target.options[e.target.selectedIndex].getAttribute('cantidad'));

  			if(index !== -1){
  				var cantidad = this.state.solicited_products[index].amount_received;
  				
  				if(cantidad !== undefined){
  					if(cantidad <= cantidad_disponible){
						this.state.solicited_products[index].amount_received = cantidad;
						this.state.solicited_products[index].lote_selected = e.target.options[e.target.selectedIndex].text;
						this.forceUpdate();
	  				}else{
	  					swal({
					        title: 'Error',
					        text: 'La cantidad ingresada es mayor a la del lote, cantidad disponible de lote es '+cantidad_disponible,
					        type: 'error',
					        closeOnConfirm: true
					    }, (isConfirm)=>{
					        if (isConfirm) {
					        	document.getElementById('prod_'+id+'_'+pos).value = '';
					        	document.getElementById('lot_'+id+'_'+pos).value = '';
	  							document.getElementById('prod_'+id+'_'+pos).focus = true;
					        }
					    }); 
						
	  				}
  				}
  			}
  		}
  	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Devolución de Productos
					</h5>
				</div>
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span className="span-min">Número de Expediente</span>
						</div>
						<div className="col-xs-12 col-sm-9">
							<span style={{color:"var(--base1)"}}>{this.state.no_file}</span>
						</div>
					</div>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right", marginTop:"10px"}}>
							<span className="span-min">Nombre de Paciente</span>
						</div>
						<div className="col-xs-12 col-sm-6">
							<span style={{color:"var(--base1)", marginRight:"20px"}}>{this.state.patient}</span>

							<span style={{color:"red", fontWeight:"bold", fontSize:"25px"}}>{this.state.group_rh}</span>
						</div>
					</div>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span className="span-min">Hospital</span>
						</div>
						<div className="col-xs-12 col-sm-9">
							<span style={{color:"var(--base1)"}}>{this.state.center_sent}</span>
						</div>
					</div>

					<fieldset className="col-xs-12">
	        			<legend>Productos solicitados</legend>
	        			<div className="col-xs-12 col-sm-6 col-sm-offset-3">
	        				
	        				<Table responsive hover>
	        					<thead>
	        						<tr>
	        							<th>Producto</th>
	        							<th>Solicitada</th>
	        							<th>Enviada</th>
	        							{/*<th>Pendiente</th>*/}
	        							<th style={{width:'12%'}}>Cantidad</th>
	        							<th>Lote</th>
	        						</tr>
	        					</thead>
	        					<tbody>
	        						{this.state.solicited_products.map((s, i)=>(
	        							
        								<tr key={i}>
											<td>{s.name}</td>
											<td>{s.amount}</td>
											<td>{s.send_amount}</td>
											{/*<td>{s.amount - s.send_amount > 0 ? s.amount - s.send_amount : 0}</td>*/}
											<td>
												<input type="number" className="form-control hour-input" min='0' 
													id={"prod_"+s.plasmatic_product_id+'_'+i}
													onChange={this.handleChange}  />
											</td>
											<td>
												<select className="form-control" id={"lot_"+s.plasmatic_product_id+'_'+i} 
													onChange={this.handleChange}>
													<option value="">Seleccione...</option>
													{s.lotes.map((l, j)=>(
														<option key={j} value={l.lote} cantidad={l.total} >
															{l.lote}
														</option>
													))}
												</select>
												
											</td>
										</tr>
										
									))}
	        					</tbody>
	        				</Table>
	        			</div>
	        		</fieldset>

	        		<div className="col-xs-12" style={{textAlign:'center'}}>
				        	
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
		        			onClick={this.onSave}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} 
		        			onClick={this.onCancel}/>
			        	
			        </div>

				</form>
		
			</div>
		)
	}
}

export default translate('translations')(DevolutionProducts);
